import { MouseEventHandler } from "react";
import QuantityControllBtnIcon from "../Icon/QuantityControllBtnIcon/QuantityControllBtnIcon";
import Text from "../Text/Text";
import CSS from "./static/css/QuantityController.module.css";

const QuantityController = (
    {
        number,
        addNumHander,
        subNumHander,
        min,
        max,
        removeHander,
        is_add_disabled,
    }:{
        number: number;
        addNumHander?: MouseEventHandler<HTMLDivElement>;
        subNumHander?: MouseEventHandler<HTMLDivElement>;
        min: number;
        max: number;
        removeHander?: MouseEventHandler<HTMLDivElement>;
        is_add_disabled?: boolean;
    }
) => {    
    return(
        <div className={CSS.l_QuantityController_main}>
            {
                removeHander && number <= min
                ?   <QuantityControllBtnIcon 
                        type="remove"
                        onClick={removeHander}
                    />
                :   <QuantityControllBtnIcon 
                        type="-"
                        is_disable={number <= min}
                        onClick={subNumHander}
                    />
            }

            <Text>
                {`${number}`}
            </Text>

            <QuantityControllBtnIcon 
                type="+"
                is_disable={is_add_disabled || number >= max}
                onClick={addNumHander}
            />
        </div>
    )
}

export default QuantityController;